
import createHTMLMapMarker from './_createHTMLMapMarker';

function mapInit(coords, center) {
	if (typeof (google) === 'undefined') {
		return;
	}

	const mapStyles = [
		{
			stylers: [
				{ 'saturation': -100 },
				{ 'lightness': 20 },
			]
		},
		{
			featureType: 'poi.business',
			elementType: 'text',
			stylers: [
				{ visibility: 'off' }
			]
		},
		{
			featureType: 'transit.station',
			stylers: [
				{ visibility: 'off' }
			]
		},
	];

	const styledMap = new google.maps.StyledMapType(mapStyles, {});
	const mapZoom = parseInt($('.contact-map').data('zoom')) || 3;
	const mapOptions = {
		clickableIcons: false,
		center: new google.maps.LatLng(42.217064, 51.273999),
		zoom: mapZoom,
		disableDefaultUI: true,
		scrollwheel: false,
		zoomControl: false,
		zoomControlOptions: {
			style: google.maps.ZoomControlStyle.LARGE,
			position: google.maps.ControlPosition.RIGHT_CENTER
		},
		mapTypeControlOptions: {
			mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
		}
	};

	const map = new google.maps.Map(
		document.getElementById('contactMap'), mapOptions
	);

	map.mapTypes.set('map_style', styledMap);
	map.setMapTypeId('map_style');
	const bounds = new google.maps.LatLngBounds();

	const optionsMarker = contactData;

	function addMarker(feature, map) {
		const latlng = new google.maps.LatLng(parseFloat(feature.coordinatesLat), parseFloat(feature.coordinatesLng));
		const marker = createHTMLMapMarker({
			latlng: latlng,
			map: map,
			html: `<div class="map-marker" data-marker-id="${feature.id}">
				<div class="map-marker__icon"></idv>
				<div class="map-marker__label">${feature.city}</idv>
			</div>`
		  });

		bounds.extend(latlng);

		google.maps.event.addListener(marker, 'click', () => {
			markerHandler(feature.id);
		});
	};

	function markerHandler(id) {
		const ww = $(window).width();
		const marker = $(`.map-marker[data-marker-id="${id}"]`);
		const offset = $(`.contact-elem[data-id="${id}"]`).offset().top;
		const headerOffset = ww <= 1024
			? (ww >= 768 ? 73 : 40)
			: 95;
		const isDesktop = ww >= 1025;

		if (isDesktop || marker.hasClass('is_focus')) {
			$('html, body').animate({
				scrollTop: offset - headerOffset
			}, 600);

			setTimeout(() => {
				$('.map-marker').removeClass('is_focus');
			}, 600);
		}

		marker.addClass('is_focus');
	}

	optionsMarker.forEach((item, i) => {
		addMarker(item, map);
	});

	map.fitBounds(bounds);
}

mapInit([55.8119548, 37.6364492], [55.810337431365, 37.63946056366]);
